import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

export type ColunasDinamicasContextData = {
    openModalColunasDinamicas: boolean;
    setOpenModalColunasDinamicas: Dispatch<SetStateAction<boolean>>;
};

type ColunasDinamicasProviderData = {
    children?: ReactNode;
};

const ColunasDinamicasContext = createContext<ColunasDinamicasContextData>({} as ColunasDinamicasContextData);

export function ColunasDinamicasProvider({ children }: ColunasDinamicasProviderData) {
    const [openModalColunasDinamicas, setOpenModalColunasDinamicas] = useState<boolean>(false);

    const contextValue = useMemo(
        () => ({
            openModalColunasDinamicas,
            setOpenModalColunasDinamicas,
        }),
        [openModalColunasDinamicas],
    );

    return <ColunasDinamicasContext.Provider value={contextValue}>{children}</ColunasDinamicasContext.Provider>;
}

export const useColunasDinamicasContext = (): ColunasDinamicasContextData => useContext(ColunasDinamicasContext);
